import { MAIN_WALLET_ID, WITHDRAWABLE_WALLET_TYPES } from '#/constants/audd';
import { IPortfolioWallet } from '#/api/v4Service';

export interface IWalletOption {
  walletId: string;
  name: string;
  balance: number;
}

export const resolveWalletId = (walletId: string | undefined | null): string => walletId || MAIN_WALLET_ID;

export const toWalletOptions = (wallets: IPortfolioWallet[], currency: string): IWalletOption[] =>
  wallets
    .filter((wallet) => WITHDRAWABLE_WALLET_TYPES.includes(wallet.type))
    .map((wallet) => ({
      walletId: wallet.wallet_id,
      name: wallet.name,
      balance: Number(wallet.holdings.find((holding) => holding.currency_id === currency)?.free_balance ?? 0),
    }))
    .sort((a, b) => {
      if (a.walletId === MAIN_WALLET_ID) return -1;
      if (b.walletId === MAIN_WALLET_ID) return 1;
      return b.balance - a.balance;
    });
